import { Box, Grid } from "@mui/material";
import ActivityFeed from "../ActivityFeed";
import ProjectChecklist from "../../Checklist";

export default function DashboardTab({
  projectData,
  isDisabled,
  setDisabled,
  initializeLoadingToast,
  updateLoadingToast,
}) {
  return (
    <Grid container spacing={2}>
      {/* Coluna Esquerda: Checklist (resumo visual) */}
      <Grid item xs={12} lg={5} sx={{ alignSelf: "flex-start" }}>
        <ProjectChecklist
          projectId={projectData.id}
          isDisabled={isDisabled}
          setDisabled={setDisabled}
          initializeLoadingToast={initializeLoadingToast}
          updateLoadingToast={updateLoadingToast}
        />
      </Grid>

      {/* Coluna Direita: Feed de Atividades */}
      <Grid item xs={12} lg={7}>
        <ActivityFeed
          projectId={projectData.id}
          projectNumber={projectData.projectNumber}
        />
      </Grid>
    </Grid>
  );
}
